import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Numbered marker badge. Colour is driven by the annotation's inferred
 * mode (NOT a user setting):
 *
 *   - element (single click)          → indigo
 *   - text (text selection)           → amber
 *   - multi-select / drag-area        → emerald (green)
 *
 * Click → remove. Right-click → edit. Both are wired by the
 * Hovercontext shell.
 */
import {} from "react";
export const MARKER_HEX = {
    element: "rgb(99 102 241)", // indigo
    text: "rgb(250 204 21)", // amber
    group: "rgb(34 197 94)", // emerald
};
export const markerModeFor = (a) => {
    if (a.selectedText !== undefined && a.selectedText.length > 0)
        return "text";
    if (a.isMultiSelect === true)
        return "group";
    return "element";
};
const styleFor = (x, y, mode, missing) => ({
    position: "absolute",
    left: `${x}px`,
    top: `${y}px`,
    transform: "translate(-50%, -50%)",
    height: "24px",
    minWidth: "24px",
    padding: "0 7px",
    borderRadius: mode === "group" ? "6px" : "999px",
    background: missing ? "rgb(63 63 70)" : MARKER_HEX[mode],
    color: missing
        ? "rgb(244 244 245)"
        : mode === "text" || mode === "group"
            ? "rgb(15 15 17)"
            : "white",
    fontSize: "12px",
    fontFamily: "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace",
    fontWeight: 700,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 0 0 2px rgb(15 15 17), 0 6px 14px rgb(0 0 0 / 0.4)",
    pointerEvents: "auto",
    cursor: "pointer",
    letterSpacing: "0.02em",
    userSelect: "none",
    zIndex: 2147483646,
    opacity: missing ? 0.7 : 1,
});
const driftGlyphStyle = {
    position: "absolute",
    top: "-6px",
    right: "-6px",
    height: "14px",
    width: "14px",
    borderRadius: "50%",
    background: "rgb(250 204 21)",
    color: "rgb(15 15 17)",
    fontSize: "9px",
    fontWeight: 800,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 0 0 2px rgb(15 15 17)",
};
const missingGlyphStyle = {
    ...driftGlyphStyle,
    background: "rgb(244 63 94)",
    color: "white",
};
export const Marker = ({ number, x, y, mode, title, drifted = false, missing = false, onRemove, onEdit, }) => {
    const onClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        onRemove?.();
    };
    const onContextMenu = (e) => {
        e.preventDefault();
        e.stopPropagation();
        onEdit?.();
    };
    return (_jsxs("span", { role: "button", tabIndex: 0, title: title ?? "Click to remove · Right-click to edit", onClick: onClick, onContextMenu: onContextMenu, style: styleFor(x, y, mode, missing), children: [number, missing && _jsx("span", { style: missingGlyphStyle, "aria-hidden": true, children: "!" }), !missing && drifted && (_jsx("span", { style: driftGlyphStyle, "aria-hidden": true, children: "\u21BB" }))] }));
};
//# sourceMappingURL=Marker.js.map